import { getIsGretaAIChatIdle } from '../GretaAIChat.utils'
import { GretaAIChatEmptyChatNotice } from '../GretaAIChatEmptyChatNotice'
import { GretaAIChatEmptyState } from '../GretaAIChatEmptyState'
import { GretaAIChatMessageListSkeleton } from '../GretaAIChatMessageListSkeleton'
import { GretaAIChatMessageListTurns } from '../GretaAIChatMessageListTurns'

import { GretaAIChatFeedContentMode } from './GretaAIChatMessageList.constants'

export function getGretaAIChatFeedContentMode({
  isNewChat,
  isSkeletonShown,
  status,
  turnsCount,
}) {
  if (turnsCount > 0) {
    return GretaAIChatFeedContentMode.Turns
  }

  if (isSkeletonShown) {
    return GretaAIChatFeedContentMode.Skeleton
  }

  if (isNewChat) {
    return GretaAIChatFeedContentMode.Greeting
  }

  if (getIsGretaAIChatIdle(status)) {
    return GretaAIChatFeedContentMode.EmptyChat
  }

  return GretaAIChatFeedContentMode.None
}

export function getGretaAIChatFeedContent({
  anchorRef,
  askElsewhereTarget,
  contentMode,
  displayName,
  feedbackByMessageId,
  isLimitReached,
  suggestedPrompts,
  turns,
  onAskElsewhere,
  onRetry,
  onSelectPrompt,
  onSendPrompt,
  onSubmitFeedback,
}) {
  switch (contentMode) {
    case GretaAIChatFeedContentMode.Turns:
      return (
        <GretaAIChatMessageListTurns
          anchorRef={anchorRef}
          askElsewhereTarget={askElsewhereTarget}
          feedbackByMessageId={feedbackByMessageId}
          isLimitReached={isLimitReached}
          turns={turns}
          onAskElsewhere={onAskElsewhere}
          onRetry={onRetry}
          onSubmitFeedback={onSubmitFeedback}
        />
      )

    case GretaAIChatFeedContentMode.Skeleton:
      return <GretaAIChatMessageListSkeleton />

    case GretaAIChatFeedContentMode.Greeting:
      return (
        <GretaAIChatEmptyState
          displayName={displayName}
          isLimitReached={isLimitReached}
          suggestedPrompts={suggestedPrompts}
          onSelectPrompt={onSelectPrompt}
          onSendPrompt={onSendPrompt}
        />
      )

    case GretaAIChatFeedContentMode.EmptyChat:
      return <GretaAIChatEmptyChatNotice />

    default:
      return null
  }
}
